import { render } from "./PostPagePart1Content.vue?vue&type=template&id=4cf21d61&scoped=true"
import script from "./PostPagePart1Content.vue?vue&type=script&lang=js"
export * from "./PostPagePart1Content.vue?vue&type=script&lang=js"

import "./PostPagePart1Content.vue?vue&type=style&index=0&id=4cf21d61&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf21d61"]])

export default __exports__